<template>
  <div class="flex items-center justify-center gap-2 lg:gap-4">
    <div v-if="isAnnualPodium" class="flex flex-col items-center">
      <div class="date-wrapper">
        <input
          ref="startDateInput"
          id="startDateInput"
          type="date"
          class="input-date cursor-pointer"
          v-model="innerStartDate"
          @input="updateDate"
          :max="innerEndDate"
          placeholder="YYYY-MM-DD"
        />
      </div>
    </div>
    <div class="flex flex-col items-center">
      <div class="date-wrapper">
        <input
          ref="endDateInput"
          id="endDateInput"
          type="date"
          class="input-date cursor-pointer"
          v-model="innerEndDate"
          @input="updateDate"
          :min="innerStartDate"
          :max="maxEndDate"
          placeholder="YYYY-MM-DD"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from '../../../../utils/eventBus';

export default {
  name: 'CalendarComponent',

  props: ['initialDate', 'finalDate', 'isAnnualPodium'],
  data() {
    return {
      innerStartDate: this.initialDate,
      innerEndDate: this.finalDate || new Date().toISOString().substring(0, 10),
    };
  },
  methods: {
    updateDate() {
      EventBus.$emit('date-changed', {
        startDate: this.innerStartDate,
        endDate: this.innerEndDate,
      });
    },
  },
  computed: {
    maxEndDate() {
      const today = new Date();
      const year = today.getFullYear();
      const month = (today.getMonth() + 1).toString().padStart(2, '0');
      const day = today.getDate().toString().padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
  },
  watch: {
    initialDate(newVal) {
      this.innerStartDate = newVal;
    },
    finalDate(newVal) {
      this.innerEndDate = newVal;
    },
  },
};
</script>

<style scoped>
.flex {
  display: flex;
}

.items-center {
  align-items: center;
}

.justify-center {
  justify-content: center;
}

.gap-4 {
  gap: 1rem;
}

.text-gray-700 {
  color: #434343;
}

.text-center {
  text-align: center;
}

.mb-1 {
  margin-bottom: 0.25rem;
}

.text-xs {
  font-size: 12px;
}

.date-wrapper {
  border: 1px solid #c1c1c1;
  border-radius: 9999px;
  padding: 8px 24px;
  display: inline-block;
}

.input-date {
  border: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  font-family: 'Poppins', sans-serif;
  color: #434343;
  outline: none;
  font-size: 12px;
  background: none;
}

.input-date::-webkit-calendar-picker-indicator {
  filter: invert(33%) sepia(6%) saturate(1170%) hue-rotate(180deg)
    brightness(97%) contrast(87%);
  width: 16px;
  height: 16px;
}
</style>
